// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1dm47","checkboxCol":"Table_checkboxCol__2u7jg","emailCol":"Table_emailCol__1sTP9","actionCol":"Table_actionCol__1esWD"};